import HighlightOff from '@mui/icons-material/HighlightOff';
import InsertDriveFile from '@mui/icons-material/InsertDriveFile';
import { IconButton, ImageListItemBar } from '@mui/material';
import type { Theme } from '@mui/material';
import { grey } from '@mui/material/colors';
import type { StyleRules, WithStyles } from '@mui/styles';
import withStyles from '@mui/styles/withStyles';

const styles = (theme: Theme): StyleRules => ({
  defaultFilePreview: {
    width: '40%',
    height: '40%',
    margin: 'auto'
  },
  deleteIcon: {
    margin: theme.spacing(1)
  }
});

type DefaultFilePreviewOwnProps = {
  attachedFile: File;
  removeAttachedFile;
};

type DefaultFilePreviewProps = DefaultFilePreviewOwnProps &
  WithStyles<typeof styles>;

const DefaultFilePreview: React.FC<DefaultFilePreviewProps> = ({
  classes,
  attachedFile,
  removeAttachedFile
}) => (
  <>
    <InsertDriveFile className={classes.defaultFilePreview} />
    <ImageListItemBar
      actionIcon={
        <IconButton
          className={classes.deleteIcon}
          onClick={removeAttachedFile}
          data-cy="removeAttachedFile"
          size="large"
        >
          <HighlightOff style={{ color: grey[50] }} />
        </IconButton>
      }
      title={attachedFile.name}
      position="top"
    ></ImageListItemBar>
  </>
);

export default withStyles(styles)(DefaultFilePreview);
